import * as a from '@mitranim/js/all.mjs'

export const FORMAT_LOCALE = `en-US`

export const LANG_EN = `en`
export const LANG_AR = `ar`
export const LANG_BN = `bn`
export const LANG_ES = `es`
export const LANG_HI = `hi`
export const LANG_JA = `ja`
export const LANG_PA = `pa`
export const LANG_PT = `pt`
export const LANG_RU = `ru`
export const LANG_ZH = `zh`

// TODO fetch from server.
// TODO add German.
export const LANGUAGES = [
  {code: LANG_EN, title: `English`},
  {code: LANG_AR, title: `Arabic (العربية)`},
  {code: LANG_BN, title: `Bengali (বাংলা)`},
  {code: LANG_ES, title: `Spanish (Español)`},
  {code: LANG_HI, title: `Hindi (हिन्दी)`},
  {code: LANG_JA, title: `Japanese (日本語)`},
  {code: LANG_PA, title: `Punjabi (ਪੰਜਾਬੀ)`},
  {code: LANG_PT, title: `Portuguese (Português)`},
  {code: LANG_RU, title: `Russian (Русский)`},
  {code: LANG_ZH, title: `Mandarin Chinese (中文)`},
]

// TODO fetch from server (part of `PubConf`).
export const LANGS = a.mapCompact(LANGUAGES, val => !val.isHidden && val.code)

export const LANG_DEFAULT = LANGS[0]
